import React from "react";
import { Container, Row, Col } from "reactstrap";

const TechStackGrid = ({ data }) => {
    if (!data) return null;

    const { tagline, title, description, categories, styles } = data;

    return (
        <section
            className="tech_stack_section"
            style={{
                background: styles?.background || "#fff",
                padding: "80px 0"
            }}
        >
            <Container>
                {/* Header */}
                <div className="sec-head">
                    <p className="eyebrow">
                        {tagline}
                    </p>

                    <h2 className="mb-3" style={{ color: styles?.titleColor }}>
                        {title}
                    </h2>

                    <p className="mx-auto" style={{ maxWidth: "750px" }}>
                        {description}
                    </p>
                </div>

                {/* Categories */}
                <Row className="g-4 tech-grid">
                    {categories.map((cat, index) => (
                        <Col md={6} lg={4} key={index}>
                            <div className="tech-card p-4 h-100">

                                {/* Header */}
                                <div className="tech-ttl d-flex align-items-center mb-3">
                                    <span className="tech-icon me-2">{cat.icon}</span>
                                    <h6 className="fw-bold text-uppercase mb-0 tech-title">
                                        {cat.title}
                                    </h6>
                                </div>

                                {/* Tags */}
                                <div className="tags d-flex flex-wrap gap-2">
                                    {cat.items.map((item, i) => (
                                        <span key={i} className="tech-tag">
                                            {item}
                                        </span>
                                    ))}
                                </div>

                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default TechStackGrid;